import { ErrorMessage } from "@hookform/error-message";
import React from "react";
import { Button, Col, Figure, Form, Row } from "react-bootstrap";
import { ValidationMessage } from "../../../../utils/constants/validationMessage";

const UploadMultiImages = ({
  register,
  errors,
  allowedTypes,
  multipleImages,
  eventDetail = {},
  handleRemoveImage,
}) => {
  return (
    <div className="wrapper mw-100 position-relative mb-5 pb-2 px-md-4 px-3">
      <span className="wrapper-heading">Upload Photo's</span>
      <Row className="mb-3 gx-sm-3 gx-2">
        <Col md={12} className="mb-3">
          <Form.Group>
            <Form.Label className="fw-bold">Upload More Photo's *</Form.Label>
            <Form.Control
              type="file"
              multiple={true}
              accept=".jpg, .jpeg, .png"
              name="multipleImage"
              {...register(`multipleImage`, {
                required:
                  multipleImages.length === 0
                    ? ValidationMessage.UPLOAD_MULTI_IMAGE_REQUIRED
                    : false,
                validate: (fileList) => {
                  const file = Array.from(fileList || []);
                  if (multipleImages?.length === 0 || file.length > 0) {
                    if (!file) return ValidationMessage.UPLOAD_MULTI_IMAGE_REQUIRED;
                    if (
                      !file.every((item) =>
                        typeof item === "object"
                          ? allowedTypes.includes(item.type)
                          : true
                      )
                    ) {
                      return "Only JPEG, JPG, and PNG files are allowed.";
                    }
                    if (
                      !file.every((item) =>
                        typeof item === "object"
                          ? (item.size < 300 * 1024)
                          : true
                      )
                    ) {
                      return "Please upload an image smaller than 300 KB.";
                    }
                  }
                  return true;
                },
              })}
            />
            <ErrorMessage
              errors={errors}
              name={`multipleImage`}
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        {multipleImages &&
          multipleImages?.map((item, index) => (
            <Col
              key={index}
              md={2}
              className="mb-3"
              style={{ position: "relative", width: "100px" }}
            >
              <Button
                className="bg-transparent border-0 p-0 ms-auto d-block"
                style={{ position: "absolute", right: "41px", top: "-12px" }}
                type="button"
                onClick={() => handleRemoveImage(item, index)}
              >
                <i className="bi bi-dash-circle-fill text-red-button-2"></i>
              </Button>
              <Figure.Image
                src={
                  typeof item === "object" ? URL.createObjectURL(item) : item
                }
                alt="No_Image"
                className="profile-image-event"
                style={{ height: "40px", width: "40px" }}
              />
            </Col>
          ))}
      </Row>
    </div>
  );
};

export default UploadMultiImages;
